import { WidgetsContext, FormContext, GatingContext, EmbedContext, Widget, SeekContext } from './core';
import { Actions } from './core/actions';
import { Shape } from './shape';
import { AssetViewer } from '../../components/AssetViewer';
import { Line } from './line';
import { HtmlView } from './html';
import { ExternalFormView } from './externalForm'
import { AnimationComponent, ParallaxContainer } from '../Animations';
import Content from './core/content';
import { MenuButton } from './menu/menuButton';
import { FilterDropdown } from './content/filters/filterDropdown';
import { AssetSearchBox } from './content/filters/searchBox';
import { SeekSearchBox } from './seek/searchInput';

const shapes = {
  Shape, Line
}

const Components = {
  HtmlView, ExternalFormView
}

const Widgets = {
  Context: WidgetsContext,
  FormContext: FormContext,
  GatingContext: GatingContext,
  SeekContext: SeekContext,
  Content: Content,
  FilterDropdown: FilterDropdown,
  AssetSearchBox: AssetSearchBox,
  Widget: Widget,
  Shapes: shapes,
  MenuButton: MenuButton,
  SeekSearchBox: SeekSearchBox,
  AssetViewer: AssetViewer,
  Actions: Actions,
  Components: Components,
  Animation: AnimationComponent,
  ParallaxContext: ParallaxContainer,
  EmbedContext: EmbedContext
}

export default Widgets;
